const SCHEDULE_LIST_OVER_RECORD = 240

export const Variables = {
  SCHEDULE_LIST_OVER_RECORD,
}
